module.exports = __webpack_public_path__ + "img/img.b57c9e7a.jpg";